/** Arabic-Indic and Eastern Arabic digits → ASCII 0–9 */
const ARABIC_INDIC = '٠١٢٣٤٥٦٧٨٩';
const EASTERN_ARABIC = '۰۱۲۳۴۵۶۷۸۹';

export function toLatinDigits(input: string): string {
  let out = '';
  for (const ch of input) {
    const ai = ARABIC_INDIC.indexOf(ch);
    if (ai >= 0) {
      out += String(ai);
      continue;
    }
    const ea = EASTERN_ARABIC.indexOf(ch);
    if (ea >= 0) {
      out += String(ea);
      continue;
    }
    out += ch;
  }
  return out;
}

/** Keep only valid decimal money characters after Latin digit normalization. */
export function filterMoneyInput(raw: string): string {
  const latin = toLatinDigits(raw);
  let out = '';
  let seenDot = false;
  for (const ch of latin) {
    if (ch >= '0' && ch <= '9') {
      out += ch;
      continue;
    }
    if (ch === '.' && !seenDot) {
      seenDot = true;
      out += ch;
    }
    if (ch === '-' && out.length === 0) out += ch;
  }
  return out;
}
